import React, { useState } from 'react';
import { TextField, MenuItem, InputAdornment, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { money } from '../../../helpers/utils';

// List of currency types
const currencyOptions = {
    MXN: { symbol: '$', label: 'MXN' }, // México
    // USD: { symbol: '$', label: 'USD' }, // USA
};

export const CurrencyInput = ({
    value,
    onChange,
    error = '',
    helperText = '',
}) => {
    const [currency, setCurrency] = useState('MXN');
    const [rawValue, setRawValue] = useState(value || '');

    // Handle the currency change
    const handleCurrencyChange = event => {
        setCurrency(event.target.value);
        if (rawValue) {
            const unformattedValue = parseFloat(
                rawValue.replace(/[^\d.-]/g, '')
            );
            const newFormattedValue = money(unformattedValue);
            setRawValue(newFormattedValue);
            onChange(newFormattedValue);
        }
    };

    // Format the monetary value in real-time
    const formatRealTime = inputValue => {
        // Remove non-numeric characters
        const cleaned = inputValue.replace(/[^\d]/g, '');
        let valueNumber = parseFloat(cleaned || 0) / 100;

        // Use the currency formatter with the selected currency
        return money(valueNumber);
    };

    // Handle the monetary value change
    const handleValueChange = event => {
        const input = event.target.value;
        const formatted = formatRealTime(input);
        setRawValue(formatted);
        // Send the formatted value in real-time
        onChange(formatted);
    };

    // Clear the input field
    const handleClear = () => {
        setRawValue('');
        onChange('');
    };

    // Get the border color based on validation state
    const getBorderColor = fieldError => {
        return fieldError ? 'red' : rawValue ? '#0D6EFD' : '';
    };

    return (
        <TextField
            label="Valor"
            value={rawValue}
            onChange={handleValueChange}
            error={!!error}
            helperText={helperText || error}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <TextField
                            select
                            value={currency}
                            onChange={handleCurrencyChange}
                            variant="standard"
                            sx={{
                                width: '100px',
                                marginRight: '10px',
                                '& .MuiSelect-select': {
                                    paddingRight: '10px',
                                },
                            }}
                        >
                            {Object.keys(currencyOptions).map(currencyCode => (
                                <MenuItem
                                    key={currencyCode}
                                    value={currencyCode}
                                >
                                    {currencyOptions[currencyCode].symbol} (
                                    {currencyOptions[currencyCode].label})
                                </MenuItem>
                            ))}
                        </TextField>
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        {rawValue && (
                            <IconButton onClick={handleClear}>
                                <ClearIcon />
                            </IconButton>
                        )}
                    </InputAdornment>
                ),
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: getBorderColor(error),
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: getBorderColor(error),
                    },
                },
            }}
            fullWidth
        />
    );
};
